import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'arrayToString', pure: true })
export class ArrayToStringPipe implements PipeTransform {
  transform(value: unknown[], separator = ', '): string {
    return value?.length ? value.join(separator) : '';
  }
}
